import { customer } from './customer';

export interface Counterpart {
  id: string;
  name: string;
  photo: string;
  city: string;
  /** Language the person writes in. */
  language: string;
}

/** Customers a chef sees in their inbox and bookings. */
export const counterparts: Counterpart[] = [
  { id: customer.id, name: customer.name, photo: customer.photo, city: customer.city, language: 'en-TH' },
  { id: 'cus-rafael', name: 'Yuki Tanabe', photo: '', city: 'Asok, Bangkok', language: 'ja-JP' },
  { id: 'cus-yuki', name: 'Chen Wei', photo: '', city: 'Ratchada, Bangkok', language: 'zh-CN' },
  { id: 'cus-nadia', name: 'Nadia Haddad', photo: '', city: 'Sathorn, Bangkok', language: 'ar-AE' },
  { id: 'cus-owen', name: 'Somsak Preecha', photo: '', city: 'Ari, Bangkok', language: 'th-TH' },
];

export function counterpartById(id: string): Counterpart {
  return counterparts.find((c) => c.id === id) ?? counterparts[0];
}
